<template>
  <v-container
    grid-list-md
    fill-height
    fluid
  >
    <v-layout
      row wrap
      justify-center
      align-center
    >
      <v-flex
        xs12
      >
        <material-card
          color="cyan"
          title="2024 Billing Procedures"
          text=""
        >
          <v-list three-line>
            <v-list-tile
              v-for="item in billingProcedures"
              :key="item.index"
            >
              <v-list-tile-content :style="{'font-weight': '300'}">
                {{ item }}
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <material-download-card
            title="Current Billing Procedures and Fees - English"
            url="./img/2026 Billing procedures and fee sched.pdf"
            sub-icon="mdi-calendar"
            sub-text="Download Billing Procedures and Fees - English"
          />
          <material-download-card
            title="Current Billing Procedures and Fees - Spanish"
            url="./img/2026 Billing procedures and fee sched-spanish.pdf"
            sub-icon="mdi-calendar"
            sub-text="Download Billing Procedures and Fees - Spanish"
          />

        </material-card>
      </v-flex>
      <v-flex
        xs12
      >
        <material-card
          color="cyan"
          title="June 14, 2025 Cross Connection Control Program"
        >
          <v-list three-line>
            <v-list-tile
              v-for="item in cccplantext"
              :key="item.index"
            >
              <v-list-tile-content :style="{'font-weight': '300'}">
                {{ item }}
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <material-download-card
            title="Cross Connection Control Program - English"
            url="./img/2025 JUNE 14 Aqua J CCCPlan-unapproved-Eng.pdf"
            sub-icon="mdi-calendar"
            sub-text="Download 2025 CCC Plan- English"
          />
          <material-download-card
            title="Cross Connection Control Program - Spanish"
            url="./img/2025 JUNE 14 Aqua J CCCPlan-unapproved-Spa.pdf"
            sub-icon="mdi-calendar"
            sub-text="Download 2025 CCC Plan-  Spanish"
          />
        </material-card>
      </v-flex>
      <v-flex
        xs12
      >
        <material-card
          color="cyan"
          title="2024 Water ShutOff Protection Policy"
          text="    Total Water Shut-offs for Non-payment 2024 = 2
"
        >
          <v-list three-line>
            <v-list-tile
              v-for="item in waterprotectionpolicytext"
              :key="item.index"
            >
              <v-list-tile-content :style="{'font-weight': '300'}">
                {{ item }}
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <material-download-card
            title=" 2024 Water Shutoff Protection Policy- English"
            url="./img/2024 Water shutoff protect policy-English.pdf"
            sub-icon="mdi-calendar"
            sub-text="Download 2024 Water Shutoff Protection Policy- English"
          />
          <material-download-card
            title="2024 Water shutoff protection policy- Spanish"
            url="./img/2024 Water shutoff protect policy-Spanish.pdf"
            sub-icon="mdi-calendar"
            sub-text="Download 2024 Water shutoff protection policy- Spanish"
          />      <material-download-card
          title=" 2024 Water Shutoff Protection Policy- Filipino"
          url="./img/2024 Water shutoff protect policy-Filipino.pdf"
          sub-icon="mdi-calendar"
          sub-text="Download 2024 Water Shutoff Protection Policy- Filipino"
        />
          <material-download-card
            title=" 2024 Water shutoff protection policy-Korean"
            url="./img/2024 Water shutoff protect policy-Korean.pdf"
            sub-icon="mdi-calendar"
            sub-text="Download 2024 Water shutoff protection policy-Korean"
          />
          <material-download-card
            title=" 2024 Water Shutoff Protection Policy- Chinese"
            url="./img/2024 Water shutoff protect policy-Chinese trad.pdf"
            sub-icon="mdi-calendar"
            sub-text="Download  2024 Water Shutoff Protection Policy- Chinese"
          />
          <material-download-card
            title=" 2024 Water shutoff protection policy- Vietnamese"
            url="./img/2024 Water shutoff protect policy-Vietnamese.pdf"
            sub-icon="mdi-calendar"
            sub-text="Download 2024 Water shutoff protection policy- Vietnamese"
          />
        </material-card>
      </v-flex>

      <v-flex
        xs12
      >
        <material-card
          color="cyan"
          title="Monthly Charges"
          text=""
        >
          <span>For all properties the base fee is $40 per Month, Metered connections will have a useage fee added.</span>
          <v-data-table
            :headers="meteredPricesHeaders"
            :items="meteredPrices"
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="priceItems"
            >
              <td class="text-xs-right">{{ formatCurrency(priceItems.item.price) }}</td>
              <td class="text-xs-right">{{ getPreviousItem(meteredPrices, priceItems.index, (item) => !item ? 0 : item.usage + 1).toLocaleString('en') }} - {{ priceItems.item.usage.toLocaleString('en') }}</td>
            </template>
          </v-data-table>

          <template slot="actions">
            <span class="caption black--text">Revised pricing Feb 1, 2026 </span>
          </template>
        </material-card>
      </v-flex>

      <v-flex
        xs12
      >
        <material-card
          color="cyan"
          title="Fees"
          text=""
        >
          <v-data-table
            :headers="feesHeaders"
            :items="fees"
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td class="text-xs-right">{{ formatCurrency(item.amount) }}</td>
              <td class="text-xs-left">{{ item.reason }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {

  },

  data: () => ({
    meteredPricesHeaders: [
      {
        sortable: false,
        text: 'Price (USD)',
        value: 'price',
        align: 'right'
      },
      {
        sortable: false,
        text: 'Water Usage (gallons)',
        value: 'usage',
        align: 'right'
      }
      ],
    meteredPrices: [
      {
        price: '40',
        usage: 0
      },
      {
        price: '40 + Rate1',
        usage: unlimited
      }
    ],
    feesHeaders: [
      {
        sortable: false,
        text: 'Fee (USD)',
        value: 'amount',
        align: 'right'
      },
      {
        sortable: false,
        text: 'Reason',
        value: 'reason',
        align: 'right'
      }
    ],
    fees: [
      {
        amount: 30,
        reason: 'Returned Check'
      },
      {
        amount: 20,
        reason: 'Late Payment Fee - 30 days past the invoice date'
      },
      {
        amount: 20,
        reason: 'Red Tag Fee (Turn off Notice) - 60 days past the invoice date'
      },
      {
        amount: 0,
        reason: 'Shut-off Water & Lock Meter - 70 days past the invoice date'
      },
      {
        amount: 100,
        reason: 'Unable to read the meter due blockage, excess debris, dogs, etc.'
      },
      {
        amount: 100,
        reason: 'Unlock Meter - Water will be available within 48hrs after full payment including all fees are received'
      },
      {
        amount: 200,
        reason: 'Cut Lock Fee- Meter will be removed if the lock is cut. '
      },
      {
        amount: '$2000-4000 - Inquire for current rate',
        reason: 'Re-install Meter - For previously installed locations.  Full payment includes all fees'
      },
      {
        amount: '$4000-10,000.00 - Inquire for current rate',
        reason: 'New Meter Installation   Must have approved county building permit and all fees paid.'
      },
      {
        amount: '10,000-20,000.00 - Inquire for current rate',
        reason: 'Fire Hydrant - If required for your building permit'
      }
    ],
    billingProcedures: [
      'Your water bill is due & payable upon presentation. Both the Invoice Date and Due Date can be found at the top of your invoice.  In order to provide accurate billings, Aqua J must receive all payments on time.',
      'Payments can be made in two ways:',
      // eslint-disable-next-line no-tabs
      '    1)	All checks or money order payments must be sent to our PO BOX. To avoid late payments be sure to get your payment in the mail, so it can reach our PO BOX by the 12th. Bills are created the 15th and will only include payments received at that time.',
      // eslint-disable-next-line no-tabs
      '    2)	Payments can be made online. Go to www.aquajmutual.com/#/pay and enter your 4 digit Account # (highlighted on your bill) and the amount you wish you to pay.  Click on “Pay thru Paypal” to complete your payment through PayPal’s secure server.  You will return to the aqujmutual website.   No PayPal account is needed to make payments, just a credit card.',
      'After incurring a late fee and Red Tag notice and you will be expected to pay the FULL AMOUNT due on your account within 70 days or your water will be shut off. If your meter has to be disconnected or removed there is a charge to reconnect/reinstall your meter.',
      'The landowner is legally responsible for any damage done to water company equipment, including damaging or tampering with the meter or cutting the lock.'

    ],
    waterprotectionpolicytext : [
      ' 1. Purpose: This policy has been established to comply with Senate Bill 998, known as the “Water Shutoff Protection Act” and approved by the Governor on September 28, 2018 (California Health and Safety Code Sections 116900, et seq.). This Policy shall be made available on the AQUA J Mutual Water Co website. The AQUA J Mutual Water Co billing office can be contacted by phone at 661-750-7525(or by email at aquajmutual@gmail.com)to discuss options for averting termination of residential water service for nonpayment under the terms of this policy. This policy does not apply to non-residential water service.',
      ' 2. Effective Date: This policy shall be effective on Dec 7, 2024.',
      '3. Published Languages: This policy and written notices required in this policy shall be available and published in English, the languages listed in Section 1632 of the Civil Code, which include Spanish, Chinese, Tagalog, Vietnamese, and Korean, and any other language spoken by at least 10 percent of the people residing in AQUA J Mutual Water Co’s water service area.\',\n' +
      '  The FULL POLICY IS FOUND BELOW in choice of languages. '
    ],
        cccplantext: [
      'The California State Water Board has mandated that all public water systems adopt a Cross Connection Control Plan (CCCP) in compliance with the States’s CCC Program Handbook.  To comply with this mandate on June 14, 2025 Aqua J Mutual Water Company adopted it’s own Cross-Connection Control Plan. Available below.'
      ]
}),
  methods: {
    getPreviousItem (items, index, evalItem) {
      let prevItem = null
      if (index) {
        prevItem = items[index - 1]
      }

      return evalItem(prevItem)
    },

    formatCurrency (amount) {
      if (amount === null || amount === undefined || amount === '') {
        return ''
      }
      if (typeof amount === 'string') {
        return amount
      }

      return `$${amount.toFixed(2)}`
    }
  }
}
</script>

<style lang="scss">
  .caption {
    font-weight: 400;
    text-align: right;
    width: 100%;
  }
</style>
